import { IPartner } from '@/interface/marketplace/Partners';
import { IPurchaseResult } from '@/interface/marketplace/PurchaseResult';
import { request, convertArrayParam } from '@lib/request';

export function getSubscribedAssetList() {
    return request({
        method: 'get',
        url: '/api/marketplace/subscribed-assets-type'
    });
}

export function getReceivables(statusList: string[], sellerId?: string) {
    let url = `/api/marketplace/fetch-receivables?${convertArrayParam('status', statusList)}`;

    if (sellerId)
        url += `&sellerId=${sellerId}`;

    return request({
        method: 'get',
        url,

    });
}

export function getLiveReceivable() {
    return request({
        method: 'get',
        url: '/api/marketplace/live-receivables',
    });
}

export function getSubAssetList(assetId: string) {
    return request({
        method: 'get',
        url: `/api/marketplace/sub-asset?receivableId=${assetId}`
    });
}

export function getReceivableDetail(receivableId: string) {
    return request({
        method: 'get',
        url: `/api/marketplace/receivable?receivableId=${receivableId}`,

    });
}

export function getSellerKeyFigure(sellerCorporateId: string) {
    return request({
        method: 'get',
        url: `/api/marketplace/seller-key-figure?sellerCorporateId=${sellerCorporateId}`,

    });
}

export function getSellerStats(sellerId: string, obligorId: string) {
    return request({
        method: 'get',
        url: `/api/marketplace/seller-statistics?sellerId=${sellerId}&obligorId=${obligorId}`
    });
}

export function purchaseAssets(assetId: string, amount: number): Promise<string> {
    return request({
        method: 'post',
        url: `/api/marketplace/purchase-receivables?assetId=${assetId}&amount=${amount}`,
    });
}

export function getReceivableSellerReportUrl(receivableId: string): Promise<string> {
    return request({
        method: 'get',
        url: `/api/marketplace/${receivableId}/seller-report`
    })
}

export function purchaseAssetWithChecking(assetId: string, amount: number): Promise<IPurchaseResult> {
    return request({
        method: 'post',
        url: `/api/marketplace/purchase-receivables-with-checking?assetId=${assetId}&amount=${amount}`,
    });
}

export function getCreditEnhancementUrl(): Promise<IPartner> {
    return request({
        method: 'get',
        url: '/api/marketplace/credit-enhancement-mapping'
    });
}